import React, { Component } from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import NominalValue from './trendEditors/NominalValue';
import NominalChange from './trendEditors/NominalChange';
import PercentChange from './trendEditors/PercentChange';
import Share from './trendEditors/Share';
import x from '../../images/js/x';

export default class TrendEditor extends Component {
    //#region React Hooks
    constructor(props) {
        super(props);
        this.state = {
            "chartId": -1,
            "connectionId": -1,
            "allConnectionIds": [],
            "dataSource": "",
            "dataSeriesDimension": "",
            "dataCategoryDimension": "",
            "connectionName" : "",
            "typeOfTrends": [
                { "id": -1, "name": "" },
                { "id": 0, "name": "Nominal Value" },
                { "id": 1, "name": "Nominal Change" },
                { "id": 2, "name": "Percent Change" },
                { "id": 4, "name": "Share" }
            ],
            "trends": [],
            "dimensions": [],
            "editorUpdates": 0,
            "info": {
                "dataSeriesDimension": ""
            },
            "globals": []
        };

        // Create the ref
        this.trendRef = React.createRef();
    }
    componentDidMount = async () => {
        let chartId = -1
        let connectionId = -1
        let allConnectionIds = []
        let dataSource = "", dataSeriesDimension = "", dataCategoryDimension = "", connectionName = ""
        let trends = []
        let info = {}
        let globals = []

        // Read in the props passed in from the parent
        if (this.props.chartId !== undefined) { chartId = this.props.chartId; }
        if (this.props.trends !== undefined) { trends = this.props.trends; }
        if (this.props.connectionId !== undefined) { connectionId = this.props.connectionId; }
        if (this.props.allConnectionIds !== undefined) { allConnectionIds = this.props.allConnectionIds; }
        if (this.props.dataSource !== undefined) { dataSource = this.props.dataSource; }
        if (this.props.dataSeriesDimension !== undefined) { dataSeriesDimension = this.props.dataSeriesDimension; }
        if (this.props.dataCategoryDimension !== undefined) { dataCategoryDimension = this.props.dataCategoryDimension; }
        if (this.props.connectionName !== undefined) { connectionName = this.props.connectionName; }
        if (this.props.info !== undefined) { info = this.props.info; }
        if (this.props.globals) {
            for (let g = 0; g < this.props.globals.length; g++) {
                if (this.props.globals[g]["dataSource"] === dataSource  || this.props.globals[g]["dataSourceAlias"] === dataSource) {
                    globals.push(this.props.globals[g])
                }
            }
        }

        let dimensions = await this.getDimensionsForTrends(connectionId, allConnectionIds, dataSource, dataSeriesDimension, dataCategoryDimension)
        if (this.trendRef.current !== null) {
            this.setState({ chartId, connectionId, allConnectionIds, dataSource, dataSeriesDimension, dataCategoryDimension, connectionName, trends, dimensions, info, globals })
        }
    };
    componentDidUpdate = async (prevProps) => {
        if (prevProps.chartId !== this.props.chartId) {
            let chartId = -1
            let connectionId = -1
            let allConnectionIds = []
            let dataSource = "", dataSeriesDimension = "", dataCategoryDimension = "", connectionName = ""
            let trends = []
            let info = {}
            let globals = []

            // Read in the props passed in from the parent
            if (this.props.chartId !== undefined) { chartId = this.props.chartId; }
            if (this.props.trends !== undefined) { trends = this.props.trends; }
            if (this.props.connectionId !== undefined) { connectionId = this.props.connectionId; }
            if (this.props.allConnectionIds !== undefined) { allConnectionIds = this.props.allConnectionIds; }
            if (this.props.dataSource !== undefined) { dataSource = this.props.dataSource; }
            if (this.props.dataSeriesDimension !== undefined) { dataSeriesDimension = this.props.dataSeriesDimension; }
            if (this.props.dataCategoryDimension !== undefined) { dataCategoryDimension = this.props.dataCategoryDimension; }
            if (this.props.connectionName !== undefined) { connectionName = this.props.connectionName; }
            if (this.props.info !== undefined) { info = this.props.info; }
            if (this.props.globals) {
                for (let g = 0; g < this.props.globals.length; g++) {
                    if (this.props.globals[g]["dataSource"] === dataSource  || this.props.globals[g]["dataSourceAlias"] === dataSource) {
                        globals.push(this.props.globals[g])
                    }
                }
            }

            let dimensions = await this.getDimensionsForTrends(connectionId, allConnectionIds, dataSource, dataSeriesDimension, dataCategoryDimension)
            if (this.trendRef.current !== null) {
                this.setState({ chartId, connectionId, allConnectionIds, dataSource, dataSeriesDimension, dataCategoryDimension, connectionName, trends, dimensions, info })
            }
        }
    };
    render() {
        if (this.state.trends.length === 0) {
            return <div className="row trends" ref={this.trendRef}>Trends Are Loading...</div>
        } else {
            return <div className="row trends" ref={this.trendRef} style={{ "overflow": "hidden" }}>
                <button className="btn" id="addTrend_btn" onClick={this.handleAddTrend}> Add New Trend </button>
                {this.state.trends.map((trendData, trendIndex) => {
                    if (this.isThisTrendTypeSupported(trendData)) {
                        return <form className="form" key={`trend-form-${trendIndex}`} style={{ marginTop: 11, position: "relative" }}>
                            {x("#77828B", "15px", ((e) => this.handleTrendRemoval(e, trendIndex)), '3px')}
                            <div className="myInputOut">
                                <input className="myInput" type="text" name="name" onChange={(event) => this.handleTrendNameChange(event, trendIndex)} value={trendData.name} placeholder="Name of Trend" />
                            </div>
                            <div className="myInputOut">
                                <Select
                                    className="myInput"
                                    onChange={(e) => this.handleTrendTypeChange(e, trendIndex)}
                                    value={trendData.type}
                                    displayEmpty
                                    inputProps={{ 'aria-label': 'Without label' }}
                                >
                                    {this.state.typeOfTrends.map((trendType) =>
                                        <MenuItem key={`trend-type-${trendType.id}`} value={trendType.id}>{trendType.name}</MenuItem>)}
                                </Select>
                            </div>
                            <div className="edit-section">
                                {this.renderTrendEditSection(trendData, this.state.dimensions, trendIndex, this.state.info.dataSeriesDimension, this.state.connectionId, this.state.allConnectionIds, this.state.dataSource, this.state.chartId, this.state.editorUpdates, this.state.connectionName, this.state.globals)}
                            </div>
                        </form>;
                    } else {
                        return <div style={{ "margin": "25px 0px" }} key={`trend-form-${trendIndex}`}>Trend Type Not Currently Supported For Edit</div>;
                    }
                })}
            </div>
        }
    }
    //#endregion

    //#region Data Handlers
    getDimensionsForTrends = async (connectionId, allConnectionIds, dataSource, dataSeriesDimension, dataCategoryDimension) => {
        let trendDimensions = [];

        for (let i = 0; i < allConnectionIds.length; i++) {
            let id = allConnectionIds[i];
            let url = `${process.env.REACT_APP_BACK_URL}/databases/${id}/${dataSource}/getconnectiondimensions`;
            let response = await this.callApi(url);
            let dimensions = response.dimensions;

            dimensions.forEach(d => {
                if (d.alias !== dataSeriesDimension && d.alias !== dataCategoryDimension && trendDimensions.find(d2 => d.alias === d2.alias) === undefined) {
                    trendDimensions.push(d);
                }
            });
        }

        return trendDimensions;
    };
    isThisTrendTypeSupported = (trendData) => {
        switch (trendData.type) {
            case 0:
            case 1:
            case 2:
            case 4:
                return true;
            default:
                return false;
        }
    };
    //#endregion

    //#region Render Methods
    renderTrendEditSection = (trendData, dimensions, trendIndex, dataSeriesDimension, connectionId, allConnectionIds, dataSource, chartId, editorUpdates, connectionName, globals) => {
        switch (trendData.type) {
            case 0:
                return <NominalValue
                    chartId={chartId}
                    trend={trendData}
                    connectionId={connectionId}
                    allConnectionIds={allConnectionIds}
                    dataSource={dataSource}
                    dimensions={dimensions}
                    editorUpdates={editorUpdates}
                    connectionName={connectionName}
                    globals={globals}
                    onSelectionChange={(trend) => {
                        this.handleChangedTrend(trend, trendIndex);
                    }}
                />;
            case 1:
                return <NominalChange
                    chartId={chartId}
                    trend={trendData}
                    connectionId={connectionId}
                    allConnectionIds={allConnectionIds}
                    dataSource={dataSource}
                    dimensions={dimensions}
                    editorUpdates={editorUpdates}
                    connectionName={connectionName}
                    globals={globals}
                    onSelectionChange={(trend) => {
                        this.handleChangedTrend(trend, trendIndex);
                    }}
                />;
            case 2:
                return <PercentChange
                    chartId={chartId}
                    trend={trendData}
                    connectionId={connectionId}
                    allConnectionIds={allConnectionIds}
                    dataSource={dataSource}
                    dimensions={dimensions}
                    editorUpdates={editorUpdates}
                    connectionName={connectionName}
                    globals={globals}
                    onSelectionChange={(trend) => {
                        this.handleChangedTrend(trend, trendIndex);
                    }}
                />
            case 4:
                return <Share
                    chartId={chartId}
                    trend={trendData}
                    connectionId={connectionId}
                    allConnectionIds={allConnectionIds}
                    dataSource={dataSource}
                    dimensions={dimensions}
                    dataSeriesDimension={dataSeriesDimension}
                    editorUpdates={editorUpdates}
                    connectionName={connectionName}
                    globals={globals}
                    onSelectionChange={(trend) => {
                        this.handleChangedTrend(trend, trendIndex);
                    }}
                />
            default:
                return <div>Trend Type Not Currently Supported For Edit</div>;
        }
    };
    //#endregion

    //#region Event Handlers
    handleTrendTypeChange = (event, index) => {
        event.preventDefault();

        let selectedNewValue = event.target.value;
        let trends = this.state.trends;
        let newName = "";

        this.state.typeOfTrends.forEach((trendType) => {
            if (trendType.id === parseInt(selectedNewValue)) {
                newName = trendType.name;
            }
        });

        trends[index]["name"] = newName;
        trends[index]["type"] = parseInt(selectedNewValue);
        this.handleChangedTrend(trends[index], index);

        this.setState({ trends: trends });
    };
    handleTrendNameChange = (event, index) => {
        event.preventDefault();

        let newName = event.target.value;
        let trends = this.state.trends;

        for (let i = 0; i < trends.length; i++) {
            if (i === index) {
                trends[i]["name"] = newName;

                this.handleChangedTrend(trends[i], index);
            }
        }

        this.setState({ trends });
    };
    handleChangedTrend = (trend, trendIndex) => {
        let trends = this.state.trends;

        for (let i = 0; i < trends.length; i++) {
            if (i === trendIndex) {
                trends[i] = trend;
            }
        }

        if (this.props.onSelectionChange) this.props.onSelectionChange(trends);
        this.setState({ trends });
    };
    handleAddTrend = (event) => {
        event.preventDefault();

        let trends = this.state.trends;
        let editorUpdates = this.state.editorUpdates;

        trends.push({
            "name": "Nominal Value",
            "type": 0,
            "baseValue": null,
            "isBaseDisplayed": false,
            "useAllOthersCalculation": false,
            "treatNullAsZero": false,
            "slicers": [],
            "selectors": [],
            "active": true,
            "referenceOnly": false,
            "showSlicers": true,
            "userFormat": ""
        });
        editorUpdates++;

        if (this.props.onSelectionChange) this.props.onSelectionChange(trends);
        this.setState({ trends, editorUpdates });
    };
    handleTrendRemoval = (event, trendIndex) => {
        event.preventDefault();

        let trends = this.state.trends;
        let editorUpdates = this.state.editorUpdates;
        let newTrends = [];

        for (let i = 0; i < trends.length; i++) {
            if (i !== trendIndex) {
                newTrends.push(trends[i]);
            }
        }

        editorUpdates++;

        if (this.props.onSelectionChange) this.props.onSelectionChange(newTrends);
        this.setState({ trends: newTrends, editorUpdates: editorUpdates });
    };
    //#endregion

    //#region Generic Calling The API
    callApi = async (url) => {
        let dataGrab = await fetch(url, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            }
        });
        let response = await dataGrab.json();
        return response;
    };
    callApiPost = async (url, postObject) => {
        let dataGrab = await fetch(url, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify(postObject)
        });
        let response = await dataGrab.json();
        return response;
    };
    //#endregion
}